import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// ErrorBoundary — React 렌더링 에러 시 흰화면 방지
class ErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { hasError: false, error: null }; }
    static getDerivedStateFromError(error) { return { hasError: true, error }; }
    componentDidCatch(error, info) { console.error('React ErrorBoundary:', error, info); }
    render() {
        if (this.state.hasError) {
            return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f8f9fa' } },
                React.createElement('p', { style: { color: '#666', fontSize: '14px' } }, '앱에 오류가 발생했습니다.'),
                React.createElement('button', { onClick: () => location.reload(), style: { marginTop: '12px', padding: '8px 20px', border: 'none', background: '#6C5CE7', color: '#fff', borderRadius: '8px', fontSize: '14px' } }, '다시 시도'),
                React.createElement('p', { style: { color: '#aaa', fontSize: '11px', marginTop: '8px', maxWidth: '80%', textAlign: 'center', wordBreak: 'break-all' } }, String(this.state.error))
            );
        }
        return this.props.children;
    }
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);

